import MasterCrudPage from '../../components/MasterCrudPage';

export default function Banks() {
  return (
    <MasterCrudPage
      config={{ title: 'Bank', apiBase: '/payroll/masters/banks', listKey: 'banks', entityKey: 'bank', fields: [], bare: true }}
    />
  );
}
